import React, { useMemo, useState } from 'react';
import { useRouteMatch, useLocation } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';
import { ExternalLayout } from '@components/ExternalLayout/ExternalLayout';
import { Container } from '@components/common/Container';

import { useStyles } from './styles';
import { StepTwo } from './StepTwo/StepTwo';
import { StepThree } from './StepThree/StepThree';

const CreateAccount = () => {
  const isPricingPage = useRouteMatch('/pricing');
  const classes = useStyles();

  const location = useLocation();

  const [step, setStep] = useState(location?.state?.step === 'step2' ? 'step2' : 'step1');
  const [googleCredential, setGoogleCredential] = useState(location?.state?.googleCredential ?? null);

  const step1 = step === 'step1';
  const step2 = step === 'step2';

  const stepLabel = useMemo(() => {
    if (step === 'step1') return 'Step 1';
    return 'Step 2';
  }, [step]);

  const handleGoogleSuccess = credential => {
    setGoogleCredential(credential);
    setStep('step2');
  };

  return (
    <ExternalLayout>
      <Container>
        <Box className={classes.createAccount}>
          <Box className={classes.heading}>
            {isPricingPage ? (
              <Box className={classes.pricePageTitleWrapper}>
                <Typography variant="h3" className={classes.pricePageTitle}>
                  Pricing
                </Typography>
              </Box>
            ) : (
              <Box className={classes.headingTitle}>
                <Typography variant="h3">Create account</Typography>
              </Box>
            )}

            {!isPricingPage ? (
              <Box>
                <Typography className={classes.headingSubTitle}>{stepLabel}</Typography>
              </Box>
            ) : null}
          </Box>
          <Box>
            <Box className={classes.stepBox}>
              {step1 && (
                <Box className={classes.stepTwoBox}>
                  <StepTwo onGoogleSuccess={handleGoogleSuccess} />
                </Box>
              )}
              {step2 && (
                <Box className={classes.stepTwoBox}>
                  <StepThree credential={googleCredential} />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </ExternalLayout>
  );
};

export default CreateAccount;
